import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

type Props = {
  Icon?: any;
  label?: string;
  placeholder: string;
  value: string;
  //   type: string;
  onChange?: any;
  //   readonly?: boolean;
  //   required?: boolean;
  name: string;
  //   multiline?: boolean;
  //   rows?: number;
  //   onClick?: any;
  error?: any;
  //   helperText?: any;
  showLabel?: boolean;
  Options: any;
};

const Dropdown = ({
  Icon,
  label,
  placeholder,
  value,
  //   type,
  onChange,
  //   readonly,
  name,
  //   multiline,
  //   rows,
  //   onClick,
  //   required,
  error,
  //   helperText,
  showLabel,
  Options,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "start",
        alignItems: "start",
        gap: "6px",
        width: "100%",
        fontFamily: "SF Pro",
      }}
    >
      {showLabel && (
        <Typography
          sx={{
            color: "#49454F",
            fontSize: 15,
            fontFamily: "SF Pro",
            fontWeight: 500,
            lineHeight: "16px",
            ml: 1.5,
          }}
        >
          {label}
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#E5E4E2",
            borderRadius: "48px",
            px: 1,
            minHeight: "50px",
            border: error ? "1px solid #D32F2F" : "1px solid transparent",
            width: "100%",
          }}
        >
          {/* ✅ Left Icon */}
          {Icon && Icon}

          {/* ✅ Select */}
          <Select
            value={value || ""}
            onChange={onChange}
            name={name}
            displayEmpty
            fullWidth
            disableUnderline
            renderValue={(selected) => {
              if (!selected) {
                return <span style={{ color: "#888888" }}>{placeholder}</span>;
              }
              return selected;
            }}
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: value ? "#000" : "#888",

              // remove outline completely
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiSelect-select": {
                paddingLeft: "8px", // or 4px / 8px
              },
            }}
          >
            <MenuItem sx={{ pl: -1 }} value="" disabled>
              <em>{placeholder}</em>
            </MenuItem>

            {Options.map((option: any, index: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {error && (
          <FormHelperText sx={{ mt: "-4px", pl: 0, color: "#D32F2F" }}>
            {error}
          </FormHelperText>
        )}
      </Box>
    </Box>
  );
};

export default Dropdown;
